/* Etiquetas: CRUD completo. */
import { label, labelInput, type Label, type LabelInput } from "@zapir/shared";
import { request } from "./core";

export const labelsApi = {
  async labels(): Promise<Label[]> {
    return request("/labels", { schema: label.array() });
  },

  async createLabel(input: LabelInput): Promise<Label> {
    const body = labelInput.parse(input);
    return request("/labels", { method: "POST", body, schema: label });
  },

  async updateLabel(id: string, input: LabelInput): Promise<Label> {
    const body = labelInput.parse({ ...input, id });
    return request(`/labels/${id}`, { method: "PUT", body, schema: label });
  },

  async deleteLabel(id: string): Promise<void> {
    await request(`/labels/${id}`, { method: "DELETE" });
  },
};
